import classnames from 'classnames';

import useStyles from './styles';

import { ImageSliderWithThumbnailCarouselProps } from './types';

const ImageSliderWithThumbnailCarouselFallback = ({
  buttonProps,
  title,
}: ImageSliderWithThumbnailCarouselProps) => {
  const styles = useStyles();
  return (
    <div className={styles.skeletonRoot}>
      {title && <i className={classnames('skeleton', styles.skeletonTitle)} />}
      <div className={styles.skeletonDots}>
        <i className={classnames('skeleton', styles.skeletonDotsItem)} />
        <i className={classnames('skeleton', styles.skeletonDotsItem)} />
        <i className={classnames('skeleton', styles.skeletonDotsItem)} />
      </div>
      <div className={styles.sekeletonItemWrapper}>
        <i className={classnames('skeleton', styles.skeletonItem)} />
        <i className={classnames('skeleton', styles.skeletonItem)} />
        <i className={classnames('skeleton', styles.skeletonItem)} />
      </div>
      <i className={classnames('skeleton', styles.sekeletonBtn)} />
      {buttonProps && <i className={classnames('skeleton', styles.sekeletonBtn)} />}
    </div>
  );
};

export default ImageSliderWithThumbnailCarouselFallback;
